import './index.css';

import * as React from 'react';
import { connect } from 'react-redux';

interface IProps {
  calling: string[];
  errorMessage: string;
}

class LoadingComponent extends React.Component<IProps> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  render() {
    if (this.props.calling.length !== 0) {
      return <div id="Loading">通信中</div>;
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state: any) => ({
  calling: state.Network.calling,
  errorMessage: state.Network.errorMessage,
  t: Date.now()
});

const mapDispatchToProps = (dispatch: any) => {
  return {};
};

const Loading = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadingComponent);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/index.tsx